import React, { useState, useEffect, forwardRef, ForwardedRef, useRef } from "react";
import { Icon } from "@citi-icg-172888/icgds-react/Icon";
import { Button } from "@citi-icg-172888/icgds-react";
import { useData } from "../services/context/DataContext";
import { handleScript } from "../services/utils/utils";
import axios from "axios";
interface CommonHeaderProps {
  toggleCardVisibility: () => void;
}

const CommonHeader: React.ForwardRefRenderFunction<HTMLHeadingElement, CommonHeaderProps> = (
  { toggleCardVisibility },
  ref: ForwardedRef<HTMLHeadingElement>
) => {
  const { isCardOpen } = useData();
  const [isCollapsed, setIsCollapsed] = useState(true);
  const [imageData, setImageData] = useState<any>("");
  const htmlRef = useRef<HTMLHeadingElement>(null);

  const handleScriptTagging = () => {
    handleScript(htmlRef, "ccbContactUsFormStart");
  };

  useEffect(() => {
    const url = (window.location.host === "uat.citigroup.com") ?
      "https://uat.citigroup.com/rcs/v1/akamaiCDN/citigpa/content/banner/businessId/commercial-bank.json"
      : "https://www.citigroup.com/rcs/v1/akamaiCDN/citigpa/content/banner/businessId/commercial-bank--1725002142949.json";

    axios.get(url)
      .then((response) => {
        setImageData(response?.data?.data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [isCardOpen]);

  return (
    <>
      <div ref={ref} id="commonHeader" className="lmn-container" style={{ padding: "27px 5px 0px" }}>
        <div ref={htmlRef}></div>
        <div className="lmn-row">
          <img
            className="lmn-col-md-2"
            src={
              imageData ? ((window.location.host === "uat.citigroup.com") ?
                `https://uat.citigroup.com/rcs/v1/siteIds/citigpa/asset/${imageData.content_json?.image}.jpg`
                : `https://www.citigroup.com/rcs/v1/siteIds/citigpa/asset/${imageData.content_json?.image}.jpg`)
                : require("../assets/imgs/Rectangle683.png")
            }
            alt=""
            aria-hidden="true"
            style={{
              height: '170px',
              borderRadius: '10px',
              display: 'block',
              objectFit: 'cover',
            }}
          />
          {/* 2nd row */}
          <div className="lmn-col-md-7 lmn-text-color-desc lmn-px-lg-6 lmn-px-xl-6 lmn-px-2xl-6 lmn-px-md-6">
            <h2 className="lmn-text-color-desc lmn-mb-md-3">
              {imageData ? imageData?.title : "Commercial Bank"}
            </h2>
            <p className="lmn-text-color-desc lmn-body-1-single">
              {imageData
                ? imageData?.content_json?.summary
                : `Citi Commercial Bank provides global banking solutions to mid-sized companies that are
              looking to grow rapidly and expand internationally.`}
            </p>
            <div className="lmn-text-color-desc lmn-body-1-single">
              <a
                href="https://www.citigroup.com/global/insights/tags/commercial-bank"
                className="lmn-text-link-quiet lmn-text-color-desc lmn-hover-underline lmn-d-none lmn-d-md-inline"
                style={{ color: "#fff !important" }}
                target="_blank"
                id="learn_more_link"
                aria-label="Learn more about Citi Commercial Bank's Global Banking Solutions"
              >
                Learn more
              </a>
              <Icon className="lmn-d-none lmn-d-md-inline lmn-p-md-4" type="arrow-right" aria-hidden="true" />
            </div>
          </div>
          {/* 3rd col */}
          <div
            id="get-in-touch"
            className="lmn-container lmn-pl-md-4 lmn-col-md-3 lmn-border-primary-color lmn-text-color-desc lmn-d-none lmn-d-md-block"
          >
            <div className="lmn-row lmn-justify-content-md-center">
              <div className="lmn-text-color lmn-heading-4 lmn-mt-md-8 lmn-mb-16px" aria-label="Get in Touch">
                Get in Touch
              </div>
            </div>
            <div className="lmn-row lmn-justify-content-md-center">
              <Button
                className="lmn-col-md-auto"
                id="contact_us"
                color="primary"
                style={{
                  background: "#255BE3",
                  borderRadius: "6px",
                }}
                onClick={() => {
                  setIsCollapsed(!isCollapsed);
                  toggleCardVisibility();
                  handleScriptTagging();
                }}
                aria-label="Contact us"
              >
                Contact us
                <Icon size="xs" type={isCardOpen ? "caret-up" : "caret-down"} />
              </Button>
            </div>
          </div>

          {/* 4th col */}
          <div className="lmn-col lmn-d-block lmn-d-md-none  lmn-px-md-8 lmn-mt-md-3">
            <Button
              color="secondary"
              className="lmn-mr-4"
              style={{
                color: "#fff",
                borderRadius: "6px",
                boxShadow: "inset 0 0 0 1px",
              }}
              onClick={() =>
                window.open("https://www.citigroup.com/global/insights/tags/commercial-bank")
              }
              aria-label="Learn more about Citi Commercial Bank's Global Banking Solutions"
            >
              Learn More
            </Button>
            <Button
              color="primary"
              onClick={() => {
                setIsCollapsed(!isCollapsed);
                toggleCardVisibility();
                handleScriptTagging();
              }}
              aria-label="Contact us"
            >
              Contact us
              <Icon size="xs" type={isCardOpen ? "caret-up" : "caret-down"} />
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

export default forwardRef(CommonHeader);
